import axios from 'axios';
import config from '../config';
import { toast } from 'react-toastify';

const axiosInstance = axios.create({
    baseURL: config.api.API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 100000,
    withCredentials: true,
});

axiosInstance.interceptors.request.use(
    config => {
        // Filtra valores vazios ou nulos antes de serem enviados ao backend
        if (config.headers['Content-Type'] !== 'multipart/form-data' && typeof config.data === 'object') {
            const filteredValues: any = {};
            for (const [key, value] of Object.entries(config.data)) {
                if (value !== '') {
                    filteredValues[key] = value;
                }
            }
            config.data = filteredValues;
        }

        // Adiciona o token de acesso à requisição
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error),
);

let failedQueue: any[] = [];
const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach(prom => {
        if (token) {
            prom.resolve(axiosInstance(prom.config));
        } else {
            prom.reject(error);
        }
    });

    failedQueue = [];
};

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Tenta atualizar o token de acesso
        if (error.response && error.response.status === 401 && error.config.url !== '/auth/login' && error.config.url !== '/user/switch-user' && error.config.url !== '/auth/reset-password') {
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject, config: originalRequest });
                    if (failedQueue.length === 1) {
                        const refreshToken = localStorage.getItem('refresh_token');
                        if (refreshToken) {
                            axios.post(`${config.api.API_URL}/auth/refresh`, { refreshToken })
                                .then(response => {
                                    const newAccessToken = response.data.access_token;
                                    const newRefreshToken = response.data.refresh_token;
                                    localStorage.setItem('access_token', newAccessToken);
                                    localStorage.setItem('refresh_token', newRefreshToken);
                                    processQueue(null, newAccessToken);
                                })
                                .catch(refreshError => {
                                    processQueue(refreshError, null);
                                    window.location.replace('/logout');
                                });
                        }
                    }
                });
            }
        }

        // Exibe as mensagens de erro do backend para o usuário
        if (error.response && (error.response.status !== 401 || error.config.url === '/auth/login' || error.config.url === '/user/switch-user' || error.config.url === '/auth/reset-password')) {
            const message = error.response.data.message;
            if (Array.isArray(message)) {
                message.forEach((value: string) => {
                    toast.error(value);
                });
            } else {
                toast.error(message);
            }
        } else if (error.message) {
            toast.error(error.message);
        }

        return Promise.reject(error);
    },
);

export default axiosInstance;